export const isLoggedIn = state => !!state.token;
export const authStatus = state => state.authStatus;
export const routeData = state => state.route;
export const getCanvas = state => state.canvas;
export const getJobByGuid = state => guid => ((state.user && state.user.jobs) || []).find(job => job.guid === guid);
export const getJobById = state => id => ((state.user && state.user.jobs) || []).find(job => job.id === id);
export const getDesignById = state => id => ((state.user && state.user.themes) || []).find(theme => theme.id === id);
export const getLinkById = state => _id => ((state.user && state.user.links) || []).find(link => link._id === _id);
export const isDeflectorRecording = state => state.deflector.isRecording;
